import React from "react";

import { Gauge } from "@mui/x-charts/Gauge";
import { useIndicators } from "../../hooks/useIndicators";
import { useWidgetFetch } from "../../hooks/useWidgetFetch";
import { RendererProps } from "./types";

export const GaugeWidget = (props: RendererProps) => {
  const { config } = props;
  const { data, isLoading, error } = useWidgetFetch(config.id, config.dataSource, props.optionValues);

  const someIndicatorView = useIndicators(props, isLoading, error);
  if (someIndicatorView) {
    return someIndicatorView;
  }

  const value = parseFloat(data as any);
  return (
    <Gauge
      width={250}
      height={250}
      value={value}
      valueMax={config.options.maxValue}
      valueMin={config.options.minValue}
      text={({ value, valueMax }) => `${value} / ${valueMax}`}
    />
  );
};
